export default __webpack_public_path__ + "static/media/orangeOrb.78d24386.svg";